"use client";

export type FolderDisplayMode = "tabs" | "sidebar";

const KEYS = {
  notificationsEnabled: "chat_notifications_enabled",
  notificationsSound: "chat_notifications_sound",
  folderDisplay: "chat_folder_display",
  sendOnEnter: "chat_send_on_enter",
} as const;

function getBool(key: string, defaultVal: boolean): boolean {
  if (typeof window === "undefined") return defaultVal;
  const v = localStorage.getItem(key);
  if (v === null) return defaultVal;
  return v === "true";
}

function setBool(key: string, val: boolean) {
  localStorage.setItem(key, String(val));
}

export function getNotificationsEnabled(): boolean {
  return getBool(KEYS.notificationsEnabled, true);
}

export function setNotificationsEnabled(val: boolean) {
  setBool(KEYS.notificationsEnabled, val);
}

export function getNotificationsSound(): boolean {
  return getBool(KEYS.notificationsSound, true);
}

export function setNotificationsSound(val: boolean) {
  setBool(KEYS.notificationsSound, val);
}

export function getFolderDisplay(): FolderDisplayMode {
  if (typeof window === "undefined") return "tabs";
  const v = localStorage.getItem(KEYS.folderDisplay);
  if (v === "tabs" || v === "sidebar") return v;
  return "tabs";
}

export function setFolderDisplay(val: FolderDisplayMode) {
  localStorage.setItem(KEYS.folderDisplay, val);
}

export function getSendOnEnter(): boolean {
  return getBool(KEYS.sendOnEnter, true);
}

export function setSendOnEnter(val: boolean) {
  setBool(KEYS.sendOnEnter, val);
}
